<template>
	<div class="surveys-tabs">
		<v-stepper no-linear :value="tabs" @input="$emit('change-tab', $event)">
			<v-stepper-header>
				<template v-for="item in items">
					<v-stepper-step
						alt-labels
						:key="`${item.number}-step`"
						:step="item.number"
						:style="`color:${$appColors.primary}`"
						:complete="item.number < tabs"
					>
						<span
							:class="`stepper-step ${items.length === 1 ? 'single' : ''} step${item.number}`"
							v-if="item.number <= tabs"
						>
							{{ item.number }}
						</span>
						{{ item.name }}
					</v-stepper-step>
					<v-divider
						:style="`border-color:${$appColors.primary} !important`"
						v-if="item.number !== items.length" :key="item.number"></v-divider>
				</template>	
			</v-stepper-header>
		</v-stepper>
	</div>
</template>
<script>
export default {
	name: 'tabs',
	props: {
		items: {
			type: [Object, Array],
			default: () => [],
		},
		tabs: {
			default: 1,
			type: Number,
		},
	},
};
</script>
<style lang="scss">
	.surveys-tabs {
		.v-stepper {
			border: 1px solid color(gray-slider);
			border-radius: 9px;
			box-shadow: none;

			&__label {
				color: currentColor !important;
				font-family: font(regular);
				font-size: size(small);
			}
	
			&__step {
				flex-direction: column;
				padding: 12px 24px !important;

				&__step {
					background: color(white) !important;
					border: 1px solid currentColor !important;
					color: currentColor !important;
					font-size: 20px;
					height: 34px;
					margin-bottom: 14px;
					position: relative;
					width: 34px;
					z-index: 1;
				}

				&:not(.v-stepper__step--inactive) {
					.v-stepper__step__step {
						background: currentColor !important;
						border: 1px solid currentColor !important;
						// color: color(white) !important;
					}

					.v-stepper__label {
						font-family: font(bold);
						font-size: 14px;
						text-shadow: none !important;
					}
				}

				&.v-stepper__step--complete {
					.v-stepper__step__step {
						background: currentColor !important;
					}
				}

				&:hover {
					background: none !important;
					
					.v-stepper__label {
						text-shadow: none !important;
					}
				}
			}

			&__header {
				height: auto;
			}
		}

		.v-divider {
			border-width: 1px;
			left: 78px;
			position: absolute;
			right: 72px;
			top: 29px;
		}
	}

	.stepper-step {
		color: color(white);
		font-family: font(bold);
		font-size: size(sbig);
		left: 68px;
		position: absolute;
		top: 14px;
		z-index: 1;

		&.single {
			left: 0px;
			margin: auto;
			right: 0px;
			width: 19px;
		}

		&.step2 {
			left: 92px;
		}

		&.step3 {
			left: 46px;
		}
	}
</style>





// WEBPACK FOOTER //
// src/components/surveys/tabs.vue